import { getSupabase } from './supabaseClient';

const BACKEND = (process.env.REACT_APP_BACKEND || 'local').toLowerCase();

export const SHOPPING_HABIT_FALLBACK_ID = 'habit-shopping';
let cachedShoppingHabitId: string | undefined;

export function getShoppingHabitId(): string | undefined {
  if (BACKEND === 'local') return SHOPPING_HABIT_FALLBACK_ID;
  return cachedShoppingHabitId ?? SHOPPING_HABIT_FALLBACK_ID;
}

export function isShoppingHabitId(id?: string): boolean {
  const shoppingId = getShoppingHabitId();
  if (!shoppingId || !id) return false;
  return id === shoppingId;
}

export async function ensureDefaultHabit(slug: 'shopping'): Promise<string> {
  if (BACKEND === 'local') return SHOPPING_HABIT_FALLBACK_ID;
  if (cachedShoppingHabitId) return cachedShoppingHabitId;
  const supabase = getSupabase();
  // Try find by slug (do not use maybeSingle to avoid PGRST116 when duplicates exist)
  const { data: rows, error: findErr } = await supabase
    .from('habits')
    .select('*')
    .eq('slug', slug)
    .eq('is_deleted', false)
    .limit(1);
  if (findErr) throw findErr;
  if (rows && rows.length > 0) {
    cachedShoppingHabitId = (rows[0] as any).id as string;
    return cachedShoppingHabitId;
  }
  // Insert default shopping habit
  const insertRow = {
    title: '買い物',
    body: 'ストック管理のための買い物習慣',
    is_deleted: false,
    slug,
  };
  const { data: created, error: insErr } = await supabase
    .from('habits')
    .insert(insertRow as any)
    .select()
    .single();
  if (insErr) throw insErr;
  cachedShoppingHabitId = created.id as string;
  return cachedShoppingHabitId;
}
